import { Stat } from "@/type/core/offices/offices.types";
import configuration from "@/utils/Config";
import { restGetHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { StatYearRequestDto } from "@state/consumptionStat/request/stat.year.request.dto";

const baseUrl = configuration.backendBaseUrl;
const consumptionYearStatUrl = baseUrl + "/ws/fo/stats/consumption/year";

export const requsetGetConsumptionStats = createEffect({
  handler: restGetHandler<Stat[], StatYearRequestDto>(consumptionYearStatUrl),
});
